<template>
  <div class="root" :class="classObj">
    <div class="main-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'content-layout',
  props: ['classObj']
}
</script>

<style scoped>
  .root {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
  }

  .ie .root {
    min-height: 100vh;
    overflow: auto;
  }

  .main-container {
    display: flex;
    flex: 1;
    width: 1024px;
    margin: 30px auto 0;
    padding-top: 20px;
    background-color: #f6f6f7;
    border-radius: 6px 6px 0 0;
    box-shadow: 0 8px 7.7px 0.3px rgba(1, 2, 2, 0.05);
    overflow: hidden;
  }
  .modal .main-container,
  .no-bg .main-container {
    flex: none;
    width: auto;
    margin: auto;
    border-radius: 6px;
  }
  .no-bg .main-container {
    border-radius: 0;
    background: none;
    box-shadow: none;
  }

  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/

  @media screen and (max-width: 1023px) {
    .no-bg .main-container {
      flex: 1;
    }
    .main-container,
    .modal .main-container {
      flex: 1;
      margin: 0;
      border-radius: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
